export const convertValueToLabel = (value: string) => {
  return value
    .split('_')
    .map((word) => word[0].toUpperCase() + word.substring(1))
    .join(' ');
};
